export const Hamburger = () => (
	<svg
		width="42"
		viewBox="0 0 42 42"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect x="14" y="8.5" width="28" height="3" rx="1.5" fill="#0D75BB" />
		<rect x="14" y="19.5" width="28" height="3" rx="1.5" fill="#0D75BB" />
		<rect x="27" y="30.5" width="15" height="3" rx="1.5" fill="#0D75BB" />
	</svg>
);
export const NewsletterIcon = () => (
	<svg
		width="64"
		viewBox="0 0 64 64"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<circle cx="32" cy="32" r="32" fill="url(#paint0_linear_250_2532)" />
		<path
			d="M21 32H43"
			stroke="white"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M34 23V23C38.9706 27.9706 38.9706 36.0294 34 41V41"
			stroke="white"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_250_2532"
				x1="9.14286"
				y1="9.14749e-07"
				x2="52.5714"
				y2="64"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#8E53F6" />
				<stop offset="0.91977" stop-color="#28D6A5" />
			</linearGradient>
		</defs>
	</svg>
);
export const HeartIcon = ({ id }) => (
	<svg
		width="43"
		height="44"
		viewBox="0 0 43 44"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g filter={`url(#filter0_b_4007_445-${id})`}>
			<ellipse
				cx="21.1628"
				cy="21.9728"
				rx="21.1628"
				ry="21.1896"
				fill="#4F4F4F"
			/>
		</g>
		<path
			d="M20.8452 15.6728L21.1627 15.9338L21.4802 15.6728C22.8553 14.5425 24.4098 14.0141 25.7963 14.0348C27.3227 14.0575 28.6535 14.748 29.292 16.0432C29.9295 17.3364 29.859 19.1958 28.6658 21.5228C27.4732 23.8487 25.1518 26.6584 21.2532 29.8751L21.2532 29.875L21.2466 29.8806C21.2379 29.888 21.2291 29.8938 21.22 29.8982L21.2198 29.8983C21.184 29.9158 21.1413 29.9158 21.1061 29.8985L21.1054 29.8982C21.0964 29.8938 21.0875 29.888 21.0788 29.8806L21.0789 29.8806L21.0722 29.8751C17.1736 26.6584 14.8522 23.8487 13.6596 21.5228C12.4664 19.1958 12.3959 17.3364 13.0334 16.0432C13.672 14.748 15.0027 14.0575 16.5291 14.0348C17.9156 14.0141 19.4701 14.5425 20.8452 15.6728Z"
			stroke="#E6E6E6"
		/>
		<defs>
			<filter
				id={`filter0_b_4007_445+${id}`}
				x="-4.03612"
				y="-3.25291"
				width="50.3978"
				height="50.4515"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix" />
				<feGaussianBlur in="BackgroundImageFix" stdDeviation="2.01806" />
				<feComposite
					in2="SourceAlpha"
					operator="in"
					result="effect1_backgroundBlur_4007_445"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_backgroundBlur_4007_445"
					result="shape"
				/>
			</filter>
		</defs>
	</svg>
);
export const VerifiedBadge = () => (
	<svg
		width="18"
		height="18"
		viewBox="0 0 18 18"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M15.3487 7.91708L14.3822 6.79427C14.1974 6.58108 14.0482 6.18312 14.0482 5.89886V4.69076C14.0482 3.93748 13.4299 3.31922 12.6766 3.31922H11.4685C11.1914 3.31922 10.7863 3.16999 10.5731 2.98522L9.45032 2.01874C8.95997 1.59946 8.15695 1.59946 7.6595 2.01874L6.54379 2.99233C6.33059 3.16999 5.92553 3.31922 5.64838 3.31922H4.41896C3.66568 3.31922 3.04742 3.93748 3.04742 4.69076V5.90596C3.04742 6.18312 2.89819 6.58108 2.72052 6.79427L1.76116 7.92419C1.34898 8.41454 1.34898 9.21046 1.76116 9.7008L2.72052 10.8307C2.89819 11.0439 3.04742 11.4419 3.04742 11.719V12.9342C3.04742 13.6875 3.66568 14.3058 4.41896 14.3058H5.64838C5.92553 14.3058 6.33059 14.455 6.54379 14.6398L7.6666 15.6062C8.15695 16.0255 8.95997 16.0255 9.45743 15.6062L10.5802 14.6398C10.7934 14.455 11.1914 14.3058 11.4757 14.3058H12.6837C13.437 14.3058 14.0553 13.6875 14.0553 12.9342V11.7261C14.0553 11.449 14.2045 11.0439 14.3893 10.8307L15.3558 9.70791C15.7679 9.21756 15.7679 8.40743 15.3487 7.91708ZM11.5112 7.46938L8.07878 10.9018C7.97929 11.0013 7.84426 11.0581 7.70214 11.0581C7.56001 11.0581 7.42498 11.0013 7.32549 10.9018L5.60574 9.18203C5.39965 8.97594 5.39965 8.63483 5.60574 8.42875C5.81182 8.22266 6.15293 8.22266 6.35902 8.42875L7.70214 9.77186L10.7579 6.7161C10.964 6.51001 11.3051 6.51001 11.5112 6.7161C11.7173 6.92218 11.7173 7.26329 11.5112 7.46938Z"
			fill="#34C759"
		/>
	</svg>
);
export const ArrowBadge = () => (
	<svg
		width="30"
		height="30"
		viewBox="0 0 30 30"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M29.9594 14.9277C29.9594 23.0228 23.397 29.5852 15.3019 29.5852C7.20679 29.5852 0.644409 23.0228 0.644409 14.9277C0.644409 6.83264 7.20679 0.270264 15.3019 0.270264C23.397 0.270264 29.9594 6.83264 29.9594 14.9277Z"
			fill="#F4F3F2"
			fill-opacity="0.32"
		/>
		<path
			d="M15.4284 9.44021L14.5647 10.3039L18.2743 14.0135L9.99144 14.0135L9.99144 15.2313L18.2743 15.2313L14.5647 18.9409L15.4284 19.8046L20.6106 14.6224L15.4284 9.44021Z"
			fill="white"
		/>
	</svg>
);

export const PlayIcon = () => (
	<svg
		width="36"
		height="36"
		viewBox="0 0 36 36"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_99_677)">
			<path
				d="M18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0ZM13.0819 25.8289V10.1711L26.642 18L13.0819 25.8289Z"
				fill="url(#paint0_linear_99_677)"
			/>
		</g>
		<defs>
			<linearGradient
				id="paint0_linear_99_677"
				x1="5.14286"
				y1="5.14546e-07"
				x2="29.5714"
				y2="36"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#8E53F6" />
				<stop offset="0.91977" stop-color="#28D6A5" />
			</linearGradient>
			<clipPath id="clip0_99_677">
				<rect width="36" height="36" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
export const ArrowUp = () => (
	<svg
		width="54"
		height="54"
		viewBox="0 0 54 54"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M47.2325 15.6665C47.228 15.5045 47.1808 15.3515 47.138 15.1963C47.1043 15.0658 47.0885 14.933 47.0323 14.8138C46.9805 14.6968 46.8928 14.6023 46.8163 14.4943C46.7218 14.357 46.6363 14.2198 46.5148 14.1073C46.4945 14.087 46.4855 14.06 46.463 14.042C46.382 13.9723 46.283 13.9475 46.1953 13.8913C46.0603 13.8035 45.9275 13.7135 45.7745 13.655C45.6238 13.601 45.4753 13.5875 45.32 13.565C45.212 13.5493 45.1153 13.4998 45.0005 13.4998H33.7505C32.5063 13.4998 31.5005 14.5078 31.5005 15.7498C31.5005 16.9918 32.5063 17.9998 33.7505 17.9998H40.109L31.028 28.5928L21.407 22.8215C20.4553 22.2455 19.2313 22.457 18.5203 23.3098L7.27025 36.8098C6.476 37.7638 6.60425 39.1835 7.55825 39.9778C7.98125 40.3288 8.48975 40.4998 8.99825 40.4998C9.644 40.4998 10.283 40.2253 10.7285 39.6898L20.7455 27.6703L30.3418 33.4303C31.2845 33.995 32.495 33.797 33.2083 32.9645L42.7505 21.8315V26.9998C42.7505 28.2418 43.7563 29.2498 45.0005 29.2498C46.2448 29.2498 47.2505 28.2418 47.2505 26.9998V15.7498C47.2505 15.7205 47.2348 15.6958 47.2325 15.6665"
			fill="#231F20"
		/>
		<mask
			id="mask0_4016_2098"
			style={{ maskType: "luminance" }}
			maskUnits="userSpaceOnUse"
			x="6"
			y="13"
			width="42"
			height="28"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M47.2325 15.6665C47.228 15.5045 47.1808 15.3515 47.138 15.1963C47.1043 15.0658 47.0885 14.933 47.0323 14.8138C46.9805 14.6968 46.8928 14.6023 46.8163 14.4943C46.7218 14.357 46.6363 14.2198 46.5148 14.1073C46.4945 14.087 46.4855 14.06 46.463 14.042C46.382 13.9723 46.283 13.9475 46.1953 13.8913C46.0603 13.8035 45.9275 13.7135 45.7745 13.655C45.6238 13.601 45.4753 13.5875 45.32 13.565C45.212 13.5493 45.1153 13.4998 45.0005 13.4998H33.7505C32.5063 13.4998 31.5005 14.5078 31.5005 15.7498C31.5005 16.9918 32.5063 17.9998 33.7505 17.9998H40.109L31.028 28.5928L21.407 22.8215C20.4553 22.2455 19.2313 22.457 18.5203 23.3098L7.27025 36.8098C6.476 37.7638 6.60425 39.1835 7.55825 39.9778C7.98125 40.3288 8.48975 40.4998 8.99825 40.4998C9.644 40.4998 10.283 40.2253 10.7285 39.6898L20.7455 27.6703L30.3418 33.4303C31.2845 33.995 32.495 33.797 33.2083 32.9645L42.7505 21.8315V26.9998C42.7505 28.2418 43.7563 29.2498 45.0005 29.2498C46.2448 29.2498 47.2505 28.2418 47.2505 26.9998V15.7498C47.2505 15.7205 47.2348 15.6958 47.2325 15.6665"
				fill="white"
			/>
		</mask>
		<g mask="url(#mask0_4016_2098)">
			<rect width="54" height="54" fill="url(#paint0_linear_4016_2098)" />
			<rect width="54" height="54" fill="url(#paint1_linear_4016_2098)" />
		</g>
		<defs>
			<linearGradient
				id="paint0_linear_4016_2098"
				x1="7.71429"
				y1="7.71819e-07"
				x2="44.3571"
				y2="54"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#8E53F6" />
				<stop offset="0.91977" stop-color="#28D6A5" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_4016_2098"
				x1="7.71429"
				y1="7.71819e-07"
				x2="44.3571"
				y2="54"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#8E53F6" />
				<stop offset="0.91977" stop-color="#28D6A5" />
			</linearGradient>
		</defs>
	</svg>
);
export const BrightnessIcon = () => (
	<svg
		width="36"
		height="37"
		viewBox="0 0 36 37"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M0.5 18.5C0.5 8.83501 8.33501 1 18 1C27.665 1 35.5 8.83501 35.5 18.5C35.5 28.165 27.665 36 18 36C8.33501 36 0.5 28.165 0.5 18.5Z"
			fill="#020204"
			stroke="#72757E"
		/>
		<path
			d="M18.0001 14C19.1936 14 20.3382 14.4741 21.1821 15.3181C22.026 16.162 22.5002 17.3066 22.5002 18.5001C22.5002 19.6936 22.0261 20.8382 21.1821 21.6821C20.3382 22.526 19.1936 23.0002 18.0001 23.0002C16.8066 23.0002 15.662 22.5261 14.8181 21.6821C13.9742 20.8382 13.5 19.6936 13.5 18.5001C13.5014 17.3069 13.9758 16.1632 14.8196 15.3196C15.6632 14.4758 16.8069 14.0014 18.0001 14M18.0001 12.5C16.4088 12.5 14.8827 13.1322 13.7573 14.2573C12.6322 15.3827 12 16.9088 12 18.5001C12 20.0914 12.6322 21.6175 13.7573 22.7429C14.8827 23.8681 16.4088 24.5002 18.0001 24.5002C19.5914 24.5002 21.1175 23.8681 22.2429 22.7429C23.3681 21.6175 24.0002 20.0914 24.0002 18.5001C24.0002 16.9088 23.3681 15.3827 22.2429 14.2573C21.1175 13.1322 19.5914 12.5 18.0001 12.5V12.5Z"
			fill="white"
		/>
		<path
			d="M18.7498 9.25V10.75C18.7498 11.0179 18.6069 11.2655 18.3748 11.3994C18.1428 11.5335 17.8568 11.5335 17.6248 11.3994C17.3928 11.2655 17.2498 11.0179 17.2498 10.75V9.25C17.2498 8.98197 17.3928 8.73438 17.6248 8.60045C17.8568 8.46652 18.1428 8.46652 18.3748 8.60045C18.6068 8.73438 18.7498 8.98198 18.7498 9.25ZM23.48 13.7698C23.6789 13.7703 23.87 13.6911 24.0101 13.5498L25.0711 12.4898H25.071C25.2607 12.3003 25.3347 12.024 25.2652 11.7652C25.1959 11.5062 24.9936 11.304 24.7346 11.2347C24.4758 11.1652 24.1996 11.2392 24.0101 11.4289L22.95 12.4898C22.8096 12.6304 22.7307 12.8211 22.7307 13.02C22.7307 13.2187 22.8096 13.4094 22.9502 13.55C23.0907 13.6906 23.2812 13.7696 23.4801 13.7698L23.48 13.7698ZM27.25 17.7499H25.75C25.4822 17.7499 25.2346 17.8928 25.1006 18.1249C24.9665 18.3569 24.9665 18.6429 25.1006 18.8749C25.2346 19.1069 25.4822 19.2499 25.75 19.2499H27.25C27.5181 19.2499 27.7657 19.1069 27.8996 18.8749C28.0335 18.6429 28.0335 18.3569 27.8996 18.1249C27.7657 17.8929 27.5181 17.7499 27.25 17.7499ZM24.0099 23.45H24.0101C23.8185 23.2715 23.548 23.2059 23.2961 23.2765C23.0441 23.3472 22.8472 23.5441 22.7766 23.796C22.7059 24.048 22.7716 24.3185 22.95 24.51L24.0101 25.5711V25.5709C24.1996 25.7606 24.4758 25.8346 24.7346 25.7651C24.9936 25.6958 25.1959 25.4936 25.2652 25.2346C25.3346 24.9758 25.2606 24.6996 25.071 24.51L24.0099 23.45ZM17.9999 25.5C17.801 25.5 17.6102 25.579 17.4696 25.7196C17.3289 25.8604 17.2499 26.0511 17.2499 26.25V27.75C17.2499 28.018 17.3929 28.2656 17.6249 28.3996C17.857 28.5335 18.1429 28.5335 18.3749 28.3996C18.607 28.2656 18.7499 28.018 18.7499 27.75V26.25C18.7499 26.0511 18.6709 25.8604 18.5303 25.7196C18.3897 25.579 18.1988 25.5 17.9999 25.5ZM11.99 23.45L10.9291 24.51C10.7394 24.6995 10.6654 24.9758 10.7349 25.2346C10.8042 25.4936 11.0064 25.6958 11.2654 25.7651C11.5242 25.8346 11.8004 25.7606 11.99 25.5709L13.05 24.51C13.2285 24.3185 13.2941 24.048 13.2235 23.796C13.1528 23.544 12.9559 23.3472 12.704 23.2765C12.452 23.2059 12.1815 23.2715 11.99 23.45L11.99 23.45ZM11 18.4999C11 18.301 10.921 18.1102 10.7804 17.9695C10.6396 17.8289 10.4489 17.7499 10.25 17.7499H8.75C8.48197 17.7499 8.23438 17.8928 8.10045 18.1249C7.96652 18.3569 7.96652 18.6429 8.10045 18.8749C8.23438 19.1069 8.48198 19.2499 8.75 19.2499H10.25C10.4489 19.2499 10.6396 19.1709 10.7804 19.0303C10.921 18.8896 11 18.6988 11 18.4999ZM11.9901 11.4288H11.99C11.8005 11.2391 11.5242 11.1651 11.2654 11.2346C11.0064 11.3039 10.8042 11.5061 10.7349 11.7651C10.6654 12.0239 10.7394 12.3001 10.9291 12.4897L11.99 13.5497C12.1815 13.7282 12.452 13.7938 12.704 13.7232C12.956 13.6525 13.1528 13.4556 13.2235 13.2037C13.2941 12.9517 13.2285 12.6812 13.05 12.4897L11.9901 11.4288Z"
			fill="white"
		/>
	</svg>
);
export const SearchIcon = () => (
	<svg
		width="36"
		height="37"
		viewBox="0 0 36 37"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M0.5 18.5C0.5 8.83501 8.33501 1 18 1C27.665 1 35.5 8.83501 35.5 18.5C35.5 28.165 27.665 36 18 36C8.33501 36 0.5 28.165 0.5 18.5Z"
			fill="#020204"
			stroke="#72757E"
		/>
		<path
			d="M20.0674 10.5001C16.7961 10.5001 14.1366 13.1598 14.1366 16.431C14.1366 17.8558 14.6412 19.162 15.4784 20.1831L15.1696 20.4919C14.3858 20.0883 13.3588 20.195 12.7177 20.8362L10.6101 22.9438C9.79664 23.7572 9.79664 25.0811 10.6101 25.8886C11.0137 26.2922 11.548 26.5 12.0824 26.5C12.6167 26.5 13.151 26.2982 13.5547 25.8886L15.6623 23.7809C16.0542 23.3891 16.2737 22.8667 16.2737 22.3086C16.2737 21.9584 16.1787 21.6259 16.0185 21.3231L16.3213 21.0203C17.3425 21.8574 18.6487 22.362 20.0735 22.362C23.3448 22.362 26.0043 19.7024 26.0043 16.4312C26.0043 13.1598 23.3387 10.5 20.0674 10.5L20.0674 10.5001ZM14.8192 22.9501L12.7115 25.0577C12.3613 25.408 11.7913 25.408 11.447 25.0577C11.0968 24.7075 11.0968 24.1375 11.447 23.7872L13.5547 21.6796C13.8931 21.3411 14.4809 21.3411 14.8192 21.6796C14.9913 21.8518 15.0804 22.0715 15.0804 22.3149C15.0804 22.5582 14.9853 22.7778 14.8192 22.9501V22.9501ZM20.0674 21.1808C17.4492 21.1808 15.324 19.0495 15.324 16.4373C15.324 13.8252 17.4493 11.6878 20.0674 11.6878C22.6855 11.6878 24.8109 13.8191 24.8109 16.4312C24.8109 19.0434 22.6796 21.1808 20.0674 21.1808ZM20.6611 13.0828C20.6611 13.4093 20.394 13.6765 20.0674 13.6765C18.5475 13.6765 17.3067 14.9113 17.3067 16.4372C17.3067 16.7637 17.0396 17.0309 16.7131 17.0309C16.3865 17.0309 16.1194 16.7637 16.1194 16.4372C16.1194 14.2582 17.8885 12.4889 20.0676 12.4889C20.3941 12.4889 20.6613 12.7501 20.6613 13.0826L20.6611 13.0828Z"
			fill="white"
		/>
	</svg>
);
export const AngleDown = () => (
	<svg
		width="12"
		height="7"
		viewBox="0 0 12 7"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M1 1L6.16129 6L11 1"
			stroke="white"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);

export const ClearIcon = ({ color }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="32"
		height="32"
		viewBox="0 0 32 32"
		fill="none"
	>
		<path
			d="M24 8L8 24"
			stroke={color ? color : "#ffffff"}
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M8 8L24 24"
			stroke={color ? color : "#ffffff"}
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
export const HamburgerIcon = () => (
	<svg
		width="32"
		viewBox="0 0 32 32"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M26.3333 16C26.3333 15.7348 26.228 15.4804 26.0404 15.2929C25.8529 15.1054 25.5986 15 25.3333 15H6.66667C6.40145 15 6.1471 15.1054 5.95956 15.2929C5.77202 15.4804 5.66667 15.7348 5.66667 16C5.66667 16.2652 5.77202 16.5196 5.95956 16.7071C6.1471 16.8946 6.40145 17 6.66667 17H25.3333C25.5986 17 25.8529 16.8946 26.0404 16.7071C26.228 16.5196 26.3333 16.2652 26.3333 16ZM26.3333 9.33333C26.3333 9.06811 26.228 8.81376 26.0404 8.62622C25.8529 8.43868 25.5986 8.33333 25.3333 8.33333H6.66667C6.40145 8.33333 6.1471 8.43868 5.95956 8.62622C5.77202 8.81376 5.66667 9.06811 5.66667 9.33333C5.66667 9.59854 5.77202 9.8529 5.95956 10.0404C6.1471 10.228 6.40145 10.3333 6.66667 10.3333H25.3333C25.5986 10.3333 25.8529 10.228 26.0404 10.0404C26.228 9.8529 26.3333 9.59854 26.3333 9.33333ZM26.3333 22.6667C26.3333 22.4014 26.228 22.1471 26.0404 21.9596C25.8529 21.772 25.5986 21.6667 25.3333 21.6667H6.66667C6.40145 21.6667 6.1471 21.772 5.95956 21.9596C5.77202 22.1471 5.66667 22.4014 5.66667 22.6667C5.66667 22.9319 5.77202 23.1862 5.95956 23.3738C6.1471 23.5613 6.40145 23.6667 6.66667 23.6667H25.3333C25.5986 23.6667 25.8529 23.5613 26.0404 23.3738C26.228 23.1862 26.3333 22.9319 26.3333 22.6667Z"
			fill="black"
		/>
	</svg>
);
export const CheckIcon = ({ id }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
	>
		<circle
			cx="12"
			cy="12"
			r="11.5"
			stroke={`url(#paint0_linear_238_2259-${id})`}
		/>
		<circle
			cx="12"
			cy="12"
			r="8"
			fill={`url(#paint1_linear_238_2259-${id})`}
		/>
		<defs>
			<linearGradient
				id={`paint0_linear_238_2259-${id}`}
				x1="3.42857"
				y1="3.43031e-07"
				x2="19.7143"
				y2="24"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#8E53F6" />
				<stop offset="0.91977" stop-color="#28D6A5" />
			</linearGradient>
			<linearGradient
				id={`paint1_linear_238_2259-${id}`}
				x1="6.28571"
				y1="4"
				x2="17.1429"
				y2="20"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#8E53F6" />
				<stop offset="0.91977" stop-color="#28D6A5" />
			</linearGradient>
		</defs>
	</svg>
);
export const UnCheckIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
	>
		<circle cx="12" cy="12" r="11.5" stroke="#A3A3A3" />
	</svg>
);
export const Discord = () => (
	<svg
		width="40"
		height="40"
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect
			opacity="0.1"
			x="0.377451"
			y="0.377451"
			width="38.5"
			height="38.5"
			fill="#020204"
			stroke="white"
			stroke-width="0.754902"
		/>
		<g clip-path="url(#clip0_110_1774)">
			<path
				d="M13.2709 26.5695L24.035 26.5695L23.521 24.9049L24.7507 25.9603L25.8778 26.9704L27.9311 28.6862L27.9311 12.437C27.8798 11.4269 27.0101 10.5686 25.9321 10.5686L13.2747 10.5709C12.1974 10.5709 11.3232 11.4307 11.3232 12.4408L11.3232 24.7004C11.3232 25.7655 12.1959 26.5695 13.2709 26.5695ZM21.2336 14.8587L21.2087 14.8678L21.2177 14.8587H21.2336ZM15.4729 15.8167C16.8567 14.8096 18.1393 14.858 18.1393 14.858L18.2427 14.9599C16.5494 15.3637 15.7817 16.1202 15.7817 16.1202C15.7817 16.1202 15.987 16.0197 16.3456 15.8665C18.6262 14.9697 21.1166 15.0346 23.4221 16.17C23.4221 16.17 22.6528 15.4626 21.0637 15.0097L21.2042 14.8715C21.4238 14.8723 22.5864 14.9131 23.8305 15.8227C23.8305 15.8227 25.2225 18.2007 25.2225 21.1221C25.1765 21.0663 24.3589 22.3798 22.255 22.4251C22.255 22.4251 21.8987 22.022 21.645 21.6702C22.8755 21.3169 23.336 20.6103 23.336 20.6103C22.9321 20.8647 22.5637 21.0157 22.2648 21.1667C21.8051 21.369 21.3446 21.4686 20.8848 21.5705C18.7077 21.9238 17.4855 21.3327 16.3305 20.864L15.9357 20.6631C15.9357 20.6631 16.3954 21.3697 17.5769 21.723C17.2666 22.0771 16.9593 22.4794 16.9593 22.4794C14.8562 22.4296 14.0892 21.1161 14.0892 21.1161C14.0892 18.1901 15.4729 15.8167 15.4729 15.8167Z"
				fill="white"
			/>
			<path
				d="M21.3684 20.2108C21.9051 20.2108 22.3422 19.7578 22.3422 19.1992C22.3422 18.6443 21.9074 18.1914 21.3684 18.1914V18.1937C20.8339 18.1937 20.396 18.6451 20.3945 19.2037C20.3945 19.7578 20.8316 20.2108 21.3684 20.2108Z"
				fill="white"
			/>
			<path
				d="M17.8825 20.2108C18.4193 20.2108 18.8563 19.7578 18.8563 19.1992C18.8563 18.6443 18.4223 18.1914 17.8855 18.1914L17.8825 18.1937C17.3458 18.1937 16.9087 18.6451 16.9087 19.2037C16.9087 19.7578 17.3458 20.2108 17.8825 20.2108Z"
				fill="white"
			/>
		</g>
		<defs>
			<clipPath id="clip0_110_1774">
				<rect
					width="18.1176"
					height="18.1176"
					fill="white"
					transform="translate(10.5688 10.5686)"
				/>
			</clipPath>
		</defs>
	</svg>
);
export const Twitter = () => (
	<svg
		width="40"
		height="40"
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect
			opacity="0.1"
			x="0.75001"
			y="0.377481"
			width="38.5"
			height="38.5"
			fill="#020204"
			stroke="white"
			stroke-width="0.754902"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M26.7624 16.2304C27.1399 21.8922 22.9879 26.4216 17.7036 26.4216C15.8828 26.4216 14.0621 26.1776 12.6336 25.4935C12.3065 25.3369 12.4344 24.9005 12.7963 24.8765C14.5553 24.7598 16.0109 24.3398 16.9487 23.402C12.8598 22.039 12.1545 16.985 12.8891 14.3486C12.9753 14.0391 13.3778 14.0374 13.54 14.3148C14.7942 16.4597 17.1791 17.6572 20.1681 17.3809C20.0387 17.0216 19.9683 16.6342 19.9683 16.2304C19.9683 14.3543 21.4892 12.8334 23.3654 12.8334C24.5115 12.8334 25.525 13.4009 26.1402 14.2703L27.4365 14.0851C27.7595 14.039 27.9849 14.3967 27.804 14.6681L26.7624 16.2304Z"
			fill="white"
		/>
	</svg>
);
export const Instagram = () => (
	<svg
		width="40"
		height="40"
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect
			opacity="0.1"
			x="1.12257"
			y="0.377481"
			width="38.5"
			height="38.5"
			fill="#020204"
			stroke="white"
			stroke-width="0.754902"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M12.8237 15.853C12.8237 13.7684 14.5136 12.0785 16.5982 12.0785H24.1473C26.2318 12.0785 27.9218 13.7684 27.9218 15.853V23.402C27.9218 25.4866 26.2318 27.1765 24.1473 27.1765H16.5982C14.5136 27.1765 12.8237 25.4866 12.8237 23.402V15.853ZM24.1473 19.6275C24.1473 21.7121 22.4574 23.402 20.3728 23.402C18.2882 23.402 16.5983 21.7121 16.5983 19.6275C16.5983 17.5429 18.2882 15.853 20.3728 15.853C22.4574 15.853 24.1473 17.5429 24.1473 19.6275ZM24.9022 15.853C25.3191 15.853 25.6571 15.515 25.6571 15.0981C25.6571 14.6811 25.3191 14.3432 24.9022 14.3432C24.4853 14.3432 24.1473 14.6811 24.1473 15.0981C24.1473 15.515 24.4853 15.853 24.9022 15.853ZM22.6375 19.6275C22.6375 20.8783 21.6236 21.8922 20.3728 21.8922C19.122 21.8922 18.1081 20.8783 18.1081 19.6275C18.1081 18.3767 19.122 17.3628 20.3728 17.3628C21.6236 17.3628 22.6375 18.3767 22.6375 19.6275Z"
			fill="white"
		/>
	</svg>
);
export const LockIcon = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="12"
		height="14"
		viewBox="0 0 12 14"
		fill="none"
	>
		<g opacity="0.7">
			<path
				d="M9.10017 4.90013V3.50009C9.10017 1.54014 7.56022 0 5.60008 0C3.64013 0.00011721 2.09999 1.54008 2.09999 3.50009V4.90013C0.909957 4.90013 0 5.81008 0 7.00012V11.9C0 13.09 0.909957 14 2.09999 14H9.09987C10.2899 14 11.1999 13.09 11.1999 11.9V7.00012C11.2 5.81008 10.2899 4.90013 9.09999 4.90013H9.10017ZM3.50009 3.50009C3.50009 2.31005 4.41005 1.4001 5.60008 1.4001C6.79012 1.4001 7.70008 2.31005 7.70008 3.50009V4.90013H3.50009V3.50009ZM6.37012 9.45027L6.30016 9.52023L6.30004 10.5003C6.30004 10.9203 6.02008 11.2002 5.60009 11.2002C5.18009 11.2002 4.90013 10.9203 4.90013 10.5003V9.52023C4.48013 9.10023 4.41017 8.47024 4.83017 8.05024C5.25017 7.63024 5.88017 7.56028 6.30016 7.98028C6.72004 8.3302 6.79012 9.03027 6.37012 9.45027H6.37012Z"
				fill="white"
			/>
		</g>
	</svg>
);
export const LockIconBigger = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="76"
		height="76"
		viewBox="0 0 76 76"
		fill="none"
	>
		<path
			d="M45.1756 33.3254V30.3753C45.1756 26.2453 41.9307 23 37.8003 23C33.6704 23.0002 30.425 26.2452 30.425 30.3753V33.3254C27.9174 33.3254 26 35.2428 26 37.7505V48.0753C26 50.583 27.9174 52.5004 30.425 52.5004H45.175C47.6826 52.5004 49.6 50.583 49.6 48.0753V37.7505C49.6003 35.2428 47.6826 33.3254 45.1752 33.3254H45.1756ZM33.3753 30.3753C33.3753 27.8677 35.2927 25.9502 37.8003 25.9502C40.3079 25.9502 42.2254 27.8677 42.2254 30.3753V33.3254H33.3753V30.3753ZM39.4229 42.9133L39.2755 43.0608L39.2753 45.1259C39.2753 46.0109 38.6853 46.6008 37.8003 46.6008C36.9153 46.6008 36.3254 46.0109 36.3254 45.1259V43.0608C35.4404 42.1758 35.293 40.8482 36.178 39.9632C37.063 39.0782 38.3905 38.9308 39.2755 39.8158C40.1603 40.5531 40.3079 42.0283 39.4229 42.9133H39.4229Z"
			fill="white"
		/>
		<path
			d="M76 38C76 58.9868 58.9868 76 38 76C17.0132 76 0 58.9868 0 38C0 17.0132 17.0132 0 38 0C58.9868 0 76 17.0132 76 38ZM4.57648 38C4.57648 56.4593 19.5407 71.4235 38 71.4235C56.4593 71.4235 71.4235 56.4593 71.4235 38C71.4235 19.5407 56.4593 4.57648 38 4.57648C19.5407 4.57648 4.57648 19.5407 4.57648 38Z"
			fill="#050506"
		/>
		<path
			d="M72.172 27.465C73.3547 27.1004 74.0242 25.8431 73.5905 24.684C70.9988 17.7566 66.4343 11.7193 60.439 7.3326C54.4438 2.94591 47.3082 0.422456 39.9214 0.0485829C38.6853 -0.0139772 37.6896 1.00459 37.7 2.24217C37.7104 3.47975 38.7232 4.46678 39.9587 4.53909C46.3803 4.91491 52.5758 7.13257 57.7925 10.9496C63.0092 14.7666 66.9978 20.0005 69.2993 26.0073C69.7421 27.163 70.9893 27.8296 72.172 27.465Z"
			fill="url(#paint0_linear_110_1713)"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_110_1713"
				x1="10.8571"
				y1="1.08626e-06"
				x2="62.4286"
				y2="76"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#8E53F6" />
				<stop offset="0.91977" stop-color="#28D6A5" />
			</linearGradient>
		</defs>
	</svg>
);
export const Plus = () => (
	<svg
		width="41"
		height="62"
		viewBox="0 0 41 62"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g filter="url(#filter0_b_110_1736)">
			<path
				d="M0 20.5C0 14.4459 0 11.4188 0.920515 9.0073C2.342 5.28341 5.28341 2.342 9.0073 0.920515C11.4188 0 14.4459 0 20.5 0C26.5541 0 29.5812 0 31.9927 0.920515C35.7166 2.342 38.658 5.28341 40.0795 9.0073C41 11.4188 41 14.4459 41 20.5V41.5C41 47.5541 41 50.5812 40.0795 52.9927C38.658 56.7166 35.7166 59.658 31.9927 61.0795C29.5812 62 26.5541 62 20.5 62C14.4459 62 11.4188 62 9.0073 61.0795C5.28341 59.658 2.342 56.7166 0.920515 52.9927C0 50.5812 0 47.5541 0 41.5V20.5Z"
				fill="#050506"
				fill-opacity="0.65"
			/>
		</g>
		<defs>
			<filter
				id="filter0_b_110_1736"
				x="-13.7435"
				y="-13.7435"
				width="68.487"
				height="89.487"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix" />
				<feGaussianBlur in="BackgroundImageFix" stdDeviation="6.87175" />
				<feComposite
					in2="SourceAlpha"
					operator="in"
					result="effect1_backgroundBlur_110_1736"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_backgroundBlur_110_1736"
					result="shape"
				/>
			</filter>
		</defs>
	</svg>
);

export const Minus = () => (
	<svg
		width="41"
		height="62"
		viewBox="0 0 41 62"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g filter="url(#filter0_b_110_1737)">
			<path
				d="M0 20.5C0 14.4459 0 11.4188 0.920515 9.0073C2.342 5.28341 5.28341 2.342 9.0073 0.920515C11.4188 0 14.4459 0 20.5 0C26.5541 0 29.5812 0 31.9927 0.920515C35.7166 2.342 38.658 5.28341 40.0795 9.0073C41 11.4188 41 14.4459 41 20.5V41.5C41 47.5541 41 50.5812 40.0795 52.9927C38.658 56.7166 35.7166 59.658 31.9927 61.0795C29.5812 62 26.5541 62 20.5 62C14.4459 62 11.4188 62 9.0073 61.0795C5.28341 59.658 2.342 56.7166 0.920515 52.9927C0 50.5812 0 47.5541 0 41.5V20.5Z"
				fill="#050506"
				fill-opacity="0.65"
			/>
		</g>
		<defs>
			<filter
				id="filter0_b_110_1737"
				x="-13.7435"
				y="-13.7435"
				width="68.487"
				height="89.487"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix" />
				<feGaussianBlur in="BackgroundImageFix" stdDeviation="6.87175" />
				<feComposite
					in2="SourceAlpha"
					operator="in"
					result="effect1_backgroundBlur_110_1737"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_backgroundBlur_110_1737"
					result="shape"
				/>
			</filter>
		</defs>
	</svg>
);
export const Instagram2 = () => (
	<svg
		width="32"
		height="32"
		viewBox="0 0 32 32"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect
			x="0.44165"
			y="0.55426"
			width="31.2334"
			height="31.2334"
			rx="15.6167"
			fill="white"
		/>
		<path
			d="M13.3051 24.6914H18.1775C22.2378 24.6914 23.8619 23.0673 23.8619 19.007V14.1346C23.8619 10.0742 22.2378 8.4501 18.1775 8.4501H13.3051C9.24474 8.4501 7.62061 10.0742 7.62061 14.1346V19.007C7.62061 23.0673 9.24474 24.6914 13.3051 24.6914Z"
			stroke="#1D004C"
			stroke-width="1.56026"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M15.7413 19.6941C17.4662 19.6941 18.8646 18.2958 18.8646 16.5708C18.8646 14.8458 17.4662 13.4474 15.7413 13.4474C14.0163 13.4474 12.6179 14.8458 12.6179 16.5708C12.6179 18.2958 14.0163 19.6941 15.7413 19.6941Z"
			stroke="#1D004C"
			stroke-width="1.86857"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);
export const Facebook2 = () => (
	<svg
		width="32"
		height="32"
		viewBox="0 0 32 32"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect
			x="0.623535"
			y="0.554169"
			width="31.2334"
			height="31.2334"
			rx="15.6167"
			fill="white"
		/>
		<path
			d="M24.4377 19.3817C24.4377 22.4424 22.6131 24.2671 19.5524 24.2671H18.5517C18.0893 24.2671 17.7109 23.8887 17.7109 23.4262V18.5745C17.7109 18.3474 17.8959 18.154 18.1229 18.154L19.6028 18.1288C19.7205 18.1204 19.8214 18.0363 19.8467 17.9186L20.141 16.3126C20.1662 16.1612 20.0485 16.0183 19.8887 16.0183L18.0977 16.0435C17.8622 16.0435 17.6772 15.8585 17.6688 15.6315L17.6352 13.5714C17.6352 13.4368 17.7445 13.3191 17.8875 13.3191L19.9055 13.2855C20.0485 13.2855 20.1578 13.1762 20.1578 13.0332L20.1241 11.0152C20.1241 10.8722 20.0148 10.7629 19.8719 10.7629L17.6016 10.7966C16.2057 10.8218 15.0958 11.9653 15.121 13.3612L15.1631 15.6735C15.1715 15.909 14.9865 16.094 14.7511 16.1024L13.742 16.1192C13.5991 16.1192 13.4898 16.2285 13.4898 16.3714L13.515 17.9691C13.515 18.112 13.6243 18.2213 13.7673 18.2213L14.7763 18.2045C15.0117 18.2045 15.1967 18.3895 15.2051 18.6165L15.2808 23.4094C15.2892 23.8803 14.9108 24.2671 14.4399 24.2671H12.506C9.44526 24.2671 7.62061 22.4424 7.62061 19.3733V12.3353C7.62061 9.27461 9.44526 7.44995 12.506 7.44995H19.5524C22.6131 7.44995 24.4377 9.27461 24.4377 12.3353V19.3817Z"
			fill="#140236"
		/>
	</svg>
);
export const Messeges2 = () => (
	<svg
		width="33"
		height="32"
		viewBox="0 0 33 32"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect
			x="0.80542"
			y="0.55426"
			width="31.2334"
			height="31.2334"
			rx="15.6167"
			fill="white"
		/>
		<path
			d="M14.1045 21.177H13.7596C11.0003 21.177 9.62061 20.4872 9.62061 17.0381V13.5889C9.62061 10.8296 11.0003 9.44995 13.7596 9.44995H19.2782C22.0375 9.44995 23.4172 10.8296 23.4172 13.5889V17.0381C23.4172 19.7974 22.0375 21.177 19.2782 21.177H18.9333C18.7194 21.177 18.5125 21.2805 18.3814 21.453L17.3467 22.8326C16.8914 23.4397 16.1464 23.4397 15.6911 22.8326L14.6564 21.453C14.546 21.3012 14.2907 21.177 14.1045 21.177Z"
			stroke="#1D004C"
			stroke-width="0.846637"
			stroke-miterlimit="10"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M19.2761 15.6584H19.2824"
			stroke="#1D004C"
			stroke-width="1.12885"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M16.5164 15.6584H16.5227"
			stroke="#1D004C"
			stroke-width="1.12885"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M13.7561 15.6583H13.7624"
			stroke="#1D004C"
			stroke-width="1.12885"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);
export const PrevIcon2 = () => (
	<svg
		width="79"
		height="58"
		viewBox="0 0 79 58"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect
			x="79"
			y="58"
			width="79"
			height="58"
			rx="10"
			transform="rotate(180 79 58)"
			fill="url(#paint0_linear_120_5168)"
		/>
		<path
			d="M59 28.5L19.5 28.5M19.5 28.5L26.8913 23M19.5 28.5L26.8913 34"
			stroke="url(#paint1_linear_120_5168)"
			stroke-width="2"
			stroke-linecap="round"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_120_5168"
				x1="90.2857"
				y1="58"
				x2="124.095"
				y2="125.863"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#8E53F6" />
				<stop offset="0.91977" stop-color="#28D6A5" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_120_5168"
				x1="18"
				y1="28"
				x2="61.5"
				y2="28"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.270833" stop-color="white" />
				<stop offset="1" stop-color="white" stop-opacity="0" />
			</linearGradient>
		</defs>
	</svg>
);

export const NextIcon2 = () => (
	<svg
		width="79"
		height="58"
		viewBox="0 0 79 58"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect
			width="79"
			height="58"
			rx="10"
			fill="url(#paint0_linear_120_5180)"
		/>
		<path
			d="M20 29.5H59.5M59.5 29.5L52.1087 35M59.5 29.5L52.1087 24"
			stroke="url(#paint1_linear_120_5180)"
			stroke-width="2"
			stroke-linecap="round"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_120_5180"
				x1="11.2857"
				y1="8.28991e-07"
				x2="45.0946"
				y2="67.8633"
				gradientUnits="userSpaceOnUse"
			>
				<stop stop-color="#8E53F6" />
				<stop offset="0.91977" stop-color="#28D6A5" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_120_5180"
				x1="61"
				y1="30"
				x2="17.5"
				y2="30"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.270833" stop-color="white" />
				<stop offset="1" stop-color="white" stop-opacity="0" />
			</linearGradient>
		</defs>
	</svg>
);


export const WebsiteIcon = () => (
	<svg
	  width="79"
	  height="58"
	  viewBox="0 0 79 58"
	  fill="none"
	  xmlns="http://www.w3.org/2000/svg"
	>
	  <circle
		cx="39.5"
		cy="29"
		r="28"
		fill="url(#paint0_linear_website_icon)"
		stroke="white"
		stroke-width="2"
	  />
	  <path
		d="M11.5 29H67.5M39.5 1V57"
		stroke="white"
		stroke-width="2"
	  />
	  <ellipse
		cx="39.5"
		cy="29"
		rx="28"
		ry="14"
		fill="none"
		stroke="white"
		stroke-width="2"
	  />
	  <defs>
		<linearGradient
		  id="paint0_linear_website_icon"
		  x1="0"
		  y1="0"
		  x2="79"
		  y2="58"
		  gradientUnits="userSpaceOnUse"
		>
		  <stop stop-color="#6A5ACD" />
		  <stop offset="1" stop-color="#6495ED" />
		</linearGradient>
	  </defs>
	</svg>
  );


  export const DocumentationIcon = () => (
	<svg
	  width="79"
	  height="58"
	  viewBox="0 0 79 58"
	  fill="none"
	  xmlns="http://www.w3.org/2000/svg"
	>
	  <rect
		x="10"
		y="4"
		width="59"
		height="50"
		rx="3"
		fill="url(#paint0_linear_documentation_icon)"
	  />
	  <path
		d="M10 14.5H69"
		stroke="white"
		stroke-width="2"
	  />
	  <path
		d="M10 24.5H69"
		stroke="white"
		stroke-width="2"
	  />
	  <path
		d="M10 34.5H69"
		stroke="white"
		stroke-width="2"
	  />
	  <path
		d="M10 44.5H49"
		stroke="white"
		stroke-width="2"
	  />
	  <defs>
		<linearGradient
		  id="paint0_linear_documentation_icon"
		  x1="0"
		  y1="0"
		  x2="79"
		  y2="58"
		  gradientUnits="userSpaceOnUse"
		>
		  <stop stop-color="#FFD700" />
		  <stop offset="1" stop-color="#FF8C00" />
		</linearGradient>
	  </defs>
	</svg>
  );

